import { cn } from '@/lib/utils';
import { Loader2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  withText?: boolean;
}

export const Loader = ({ className, withText = true }: Props) => {
  const { t } = useTranslation();

  const loaderIcon = (
    <Loader2Icon
      aria-label={ t('ariaLabels.loading') }
      className={ cn('animate-spin size-10 text-text-brand', className) }
    />
  );

  if (!withText) return loaderIcon;

  return (
    <div className="flex flex-col items-center gap-space-2xs">
      { loaderIcon }
      <p>{ t('loading') }</p>
    </div>
  );
};
